import * as XLSX from "xlsx";

/** Read the header row (first row) of an .xlsx / .xls / .csv file, client-side.
 *  Used to drive the AI column-mapping step before upload. Returns the trimmed,
 *  non-empty header strings in column order. */
export async function readFileHeaders(file: File): Promise<string[]> {
    const buf = await file.arrayBuffer();
    const wb = XLSX.read(buf, { type: "array" });
    const sheetName = wb.SheetNames[0];
    if (!sheetName) return [];
    const sheet = wb.Sheets[sheetName];
    const rows = XLSX.utils.sheet_to_json<unknown[]>(sheet, { header: 1, blankrows: false });
    const headerRow = (rows[0] ?? []) as unknown[];
    return headerRow.map((h) => String(h ?? "").trim()).filter((h) => h.length > 0);
}

/** Generate and download a blank .xlsx with a single header row, so users can
 *  fill it in and re-upload against the template. */
export function downloadBlankTemplate(filename: string, headers: string[]): void {
    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.writeFile(wb, filename);
}
